var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdIconModule } from '@angular/material';
import { TdMessageComponent, TdMessageContainerDirective } from './message.component';
var TD_MESSAGE = [
    TdMessageComponent,
    TdMessageContainerDirective,
];
export { TdMessageComponent } from './message.component';
var CovalentMessageModule = (function () {
    function CovalentMessageModule() {
    }
    return CovalentMessageModule;
}());
CovalentMessageModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            MdIconModule,
        ],
        declarations: [
            TD_MESSAGE,
        ],
        exports: [
            TD_MESSAGE,
        ],
    })
], CovalentMessageModule);
export { CovalentMessageModule };
//# sourceMappingURL=message.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@covalent/core/message/message.module.js
// module id = ../../../../@covalent/core/message/message.module.js
// module chunks = 4